import React from 'react';
import Icon from '../icons/Icon';

interface ErrorStateProps {
  /** Plain language: what failed, in the reader's terms. */
  title?: string;
  /** The technical detail. Shown, but subordinate to the next step. */
  detail?: string;
  onRetry?: () => void;
  className?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'This panel could not load',
  detail,
  onRetry,
  className = '',
}) => (
  <div
    role="alert"
    className={`rounded-card border border-negative/25 bg-negative-bg/60 p-5 ${className}`}
  >
    <div className="flex items-start gap-3">
      <span className="mt-0.5 text-negative">
        <Icon name="alert" className="h-5 w-5" />
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="text-sm font-semibold text-ink">{title}</h3>
        <p className="mt-1 text-sm leading-6 text-ink-2">
          The data behind it did not come back. Retrying usually clears a one-off network
          failure; if it keeps happening, check the API service in Sys &amp; Dev Ops.
        </p>
        {detail ? (
          <p className="mt-2 break-words font-mono text-xs text-ink-3">{detail}</p>
        ) : null}
        {onRetry ? (
          <button
            type="button"
            onClick={onRetry}
            className="mt-3 inline-flex items-center gap-1.5 rounded-lg border border-border-default bg-surface px-3 py-1.5 text-sm font-semibold text-ink-2 transition-colors hover:bg-surface-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2"
          >
            <Icon name="refresh" className="h-4 w-4" />
            Try again
          </button>
        ) : null}
      </div>
    </div>
  </div>
);

export default ErrorState;
